














































    import {Vue, Component, Prop} from 'vue-property-decorator'
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase.ts";
import dataProxy from "@/services/data-proxy.service"
import {StavkaIzvestajaSipanjaIPotrosnjeGoriva} from "@/services/BackendProxies";
import moment from "moment";
    import {formatDate, formatInteger, formatPrice} from "@/utils/formatters";
    import * as _ from "lodash";

@Component({})
export default class Tab2 extends TabBase {
    dataSource: StavkaIzvestajaSipanjaIPotrosnjeGoriva[] = [];
    columns = [];
    options = {
        pagination: true,
        /*showFooter: true,
        footerStyle: () => {
            return {css: {'font-weight': 'bold'}}
        },*/
    };
    chartOptions = {
        xaxis: {show: false},
    };

    stavka = new StavkaIzvestajaSipanjaIPotrosnjeGoriva();
    edit: StavkaIzvestajaSipanjaIPotrosnjeGoriva;
    dijalogOtvoren = false;

    get chartData() {
        const sixMonths = moment().subtract(6, 'month').toDate();
        const lastSixMonths = this.dataSource.filter(x => x.datum > sixMonths);
        const prosecnaPotrosnja = lastSixMonths.map(x => [x.datum, x.prosecnaPotrosnjaGoriva]);
        return [{label: this.$i18n.t('prosecnaPotrosnja'), data: prosecnaPotrosnja, color: '#ff9800'}];
    };

    async created() {
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate, width: 100},
            {field: 'gorivo', title: this.$i18n.t('gorivo'), width: 80},
            {
                field: 'stanjeKilometrazePriSipanju', title: this.$i18n.t('stanjeKilometrazePriSipanju'),
                formatter: formatInteger, width: 120, align: 'right',
                footerFormatter: this.$i18n.t('total')
            },
            {
                field: 'sipanaKolicina',
                title: this.$i18n.t('sipanaKolicina'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'sipanaKolicina')),
            },
            {
                field: 'vrednostSipanogGoriva',
                title: this.$i18n.t('vrednostSipanogGoriva'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'vrednostSipanogGoriva'))
            },
            {
                field: 'prosecnaPotrosnjaGoriva',
                title: this.$i18n.t('prosecnaPotrosnjaGoriva'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => {
                    const predjenoKm = _.sumBy(items, 'predjenoKilometaraNakonPrethodnogSipanja');
                    const sipano = _.sumBy(items, 'sipanaKolicina');
                    return formatPrice(predjenoKm ? sipano * 100 / predjenoKm : 0);
                }
            },
            {
                field: 'prekoracenjeNorme',
                title: this.$i18n.t('prekoracenjeNorme'),
                formatter: formatPrice,
                width: 120,
                align: 'right'
            },
        ];

        const odDatuma = new Date(2010, 1, 1);
        const doDatuma = new Date();
        const dataSource = await this.loadData(() => dataProxy.vratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(odDatuma, doDatuma, this.vozilo.id))();
        this.dataSource = dataSource.sort((r1, r2) => r1.datum < r2.datum ? 1 : -1);
    }

    get ukupnoSipanoGorivo() {
        return _.sumBy(this.dataSource, 'sipanaKolicina');
    }

    get ukupnaVrednostSipanogGoriva() {
        return _.sumBy(this.dataSource, 'vrednostSipanogGoriva');
    }

    get prosecnaPotrosnja() {
        const predjenoKm = _.sumBy(this.dataSource, 'predjenoKilometaraNakonPrethodnogSipanja');
        const sipanoGorivo = _.sumBy(_.take(this.dataSource, this.dataSource.length - 1), 'sipanaKolicina');
        return predjenoKm ? sipanoGorivo * 100 / predjenoKm : 0;
    }

    rowClick(row) {
        this.stavka = StavkaIzvestajaSipanjaIPotrosnjeGoriva.fromJS(row);
        this.edit = row;
        this.dijalogOtvoren = true;
    }

    sacuvajNovuKilometrazu() {
        this.edit.stanjeKilometrazePriSipanju = this.stavka.stanjeKilometrazePriSipanju;
        this.saveData(() => dataProxy.sacuvajStavkuSipanjaGoriva(this.edit))();
        this.dijalogOtvoren = false;
    }
}
